/**
 * React Query hooks for index channel operations
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { parseIndexChannel, importIndexChannel } from '@/api/indexChannel';
import {
  ParseIndexChannelRequest,
  ParseIndexChannelResponse,
  ImportIndexChannelRequest,
  ImportIndexChannelResponse,
} from '@/types/indexChannel';
import { getErrorMessage } from '@/api/client';

/**
 * Hook to parse index channel and extract library sections
 */
export const useParseIndexChannel = () => {
  return useMutation<ParseIndexChannelResponse, Error, ParseIndexChannelRequest>({
    mutationFn: parseIndexChannel,
    onError: (error) => {
      console.error('Failed to parse index channel:', getErrorMessage(error));
    },
  });
};

/**
 * Hook to import library sections from parsed index channel
 */
export const useImportIndexChannel = () => {
  const queryClient = useQueryClient();

  return useMutation<ImportIndexChannelResponse, Error, ImportIndexChannelRequest>({
    mutationFn: importIndexChannel,
    onSuccess: () => {
      // Invalidate library sections cache after import
      queryClient.invalidateQueries({ queryKey: ['library-sections'] });
      queryClient.invalidateQueries({ queryKey: ['libraries'] });
    },
    onError: (error) => {
      console.error('Failed to import index channel:', getErrorMessage(error));
    },
  });
};
